import React, { useState, useEffect } from "react";
import { EventApplicationService } from "../../../services";
import { AuthService } from "../../../services";
import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import {
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { ApplicationStatus } from "../../../constants/Enum";
import { toast } from "react-toastify";
//import _ from "lodash";

const EventRetailerSubmissionList = (props) => {
  const loginUser = AuthService.getLoginUser();
  const { eventId } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getEventData();
  }, []);

  const getEventData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        const res = await EventApplicationService.getSubmitterRetailerAppByEventId(
          eventId
        );
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data?.filter((x) => x.isActive === true));
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  const getObscuredTextLabel = (isApproved, text) => {
    return !isApproved ? text : "*************";
  };
  const getObscuredText = (isApproved) => {
    return isApproved ? { filter: "blur(4px)" } : {};
    // return {};
  };

  const handleView = async (id, name) => {
    try {
      navigate(
        routes.SUBMISSION_RETAILER_DETAILS.replace(":eventId", eventId).replace(
          ":appId",
          id
        )
      );
    } catch (error) {}
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Pitch Title</th>
                  <th>Retailer Name</th>
                  <th>On Site Contact </th>
                  <th>Pay Out Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.pitchName}</td>

                          <td
                            style={getObscuredText(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true
                            )}
                          >
                            {getObscuredTextLabel(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true,
                              item?.traderName
                            )}
                          </td>
                          <td
                            style={getObscuredText(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true
                            )}
                          >
                            {getObscuredTextLabel(
                              item?.status === ApplicationStatus.Approved ||
                                item?.status === ApplicationStatus.Completed
                                ? false
                                : true,
                              item.onSiteContact
                            )}
                          </td>
                          <td>
                            {" "}
                            {item.payOutDate
                              ? formatDateENGB(item?.payOutDate)
                              : "NA"}
                          </td>
                          <td>{item?.statusName}</td>
                          <td>
                            <div className="delete-create">
                              <Link
                                title="View Application"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleView(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                              <a
                                href={
                                  item?.traderProfileUrl +
                                  "trader-profile-organizer-retailer"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Trader Profile"
                              >
                                <i className="fa fa-user-circle"></i>
                              </a>
                              {/* <Link
                                to={`${routes.TRADER_PROFILE.replace(
                                  ":id",
                                  item?.traderId
                                ).replace(
                                  ":eventUrl",
                                  "trader-profile-organizer"
                                )}`}
                              >
                                <i className="fa fa-user-circle"></i>
                              </Link> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventRetailerSubmissionList);
